import React from 'react';

const donationHeaderBiblicalGuideForgiveness = ({ firstName }) => (
  <div>
    <h2
      style={{
        fontSize: '40px',
        textAlign: 'center',
        color: '#4a4a4a',
      }}
    >
      Good News {firstName}! Your resource is on its way to your inbox.
    </h2>
    <br></br>
    <div>
      <p>
        We praise God for your heart to discover more about forgiveness. We hope
        this resource encourages you with Scripture’s powerful promise that{' '}
        <em>“compassion and forgiveness belong to the Lord our God”</em> (Daniel
        9:9, HCSB).
      </p>
      <br />
      <p>
        <strong>
          Before you go, there are a few things we’d like you to know…
        </strong>
      </p>
      <br />
      <p>
        The Billy Graham Evangelistic Association is able to offer ministry like
        this because of friends like you. The Lord is using the gifts and
        prayers of believers like you to reach people across the globe with His
        love—and there are so many more who need to hear the Good News.
      </p>
      <br />
      <p>
        <strong>Will you give them the opportunity to hear it?</strong>
      </p>
      <br />
      <blockquote>
        Your gift of $50 today will help share the Gospel with people around the
        world who are far from God and equip them with powerful Biblical
        resources to become faithful followers of Christ.
      </blockquote>
    </div>
  </div>
);

export default donationHeaderBiblicalGuideForgiveness;
